import { Modal, Form, Input, Radio, Select, message } from 'antd'
import { useEffect, useState } from 'react'
import '../index.less'
import service from '../../../../@services'
const { Option } = Select
const ShipNoModal = ({
  visible,
  record,
  close = () => {},
  storeCode,
  update = () => {}
}) => {
  const [form] = Form.useForm()
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [companiesOptions, setCompaniesOptions] = useState([])
  useEffect(() => {
    service.delivery.companiesList().then(res => {
      setCompaniesOptions(res)
    })
  }, [])
  //操作
  const onOk = async () => {
    try {
      await form.validateFields()
      setConfirmLoading(true)
      const companyNo = form.getFieldValue('companyNo')
      let deliveryCompany = ''
      const index = companiesOptions.findIndex(
        item => item.companyNo == companyNo
      )
      if (index > -1) {
        deliveryCompany = companiesOptions[index].deliveryCompany
      }
      await service.delivery.delivery({
        ...form.getFieldsValue(),
        ...{
          deliveryCompany: deliveryCompany,
          orderNo: record.orderNo,
          storeCode: storeCode.join('')
        }
      })
      setConfirmLoading(false)
      await message.success('发货成功', 1)
      update('delivery')
    } catch (e) {
      setConfirmLoading(false)
      console.log(e)
    }
  }
  const onCancel = () => {
    form.resetFields()
    // form.setFieldsValue({deliveryWay: null, companyNo: null, deliveryCode: null})
    if (close) {
      close()
    }
  }
  useEffect(() => {
    form.resetFields()
    // form.setFieldsValue({companyNo: record.companyNo, deliveryCode: record.deliveryCode})
  }, [record])
  return (
    <Modal
      className='ship-modal'
      title='订单发货'
      confirmLoading={confirmLoading}
      visible={visible}
      onCancel={onCancel}
      okText='确认并发货'
      onOk={onOk}>
      <Form name='shipModal' form={form}>
        <Form.Item
          label='发货方式'
          name='deliveryWay'
          rules={[{ required: true, message: '请选择发货方式' }]}>
          <Radio.Group>
            <Radio.Button value='MERCHANT'>供应商代发</Radio.Button>
            <Radio.Button value='STORE'>门店发货</Radio.Button>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          name='companyNo'
          label='快递公司'
          rules={[{ required: true, message: '请选择快递公司' }]}>
          <Select
            placeholder='请选择快递公司'
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }>
            {companiesOptions.map((item, index) => (
              <Option key={index} value={item.companyNo}>
                {item.deliveryCompany}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name='deliveryCode'
          label='物流单号'
          getValueFromEvent={event =>
            event.target.value.trim().replace(/[\u4E00-\u9FA5]/g, '')
          }
          rules={[{ required: true, message: '请选择物流单号' }]}>
          <Input allowClear placeholder='请输入物流单号' />
        </Form.Item>
      </Form>
    </Modal>
  )
}
export default ShipNoModal
